module.exports = __webpack_public_path__ + "img/ziben.f7dfc92c.png";